export default "<app-header></app-header>\n<app-content></app-content>\n<app-footer></app-footer>\n<ngx-json-ld [json]=\"jsonLd\"></ngx-json-ld>\n"